module.exports = __webpack_public_path__ + "img/kws.32c5f64a.svg";